import React, { useState } from 'react'
import { Button } from '@mui/material'
import { makeKiddomPostRequest } from 'infrastructure/api'
import { useNotify } from 'shared/ui/Notify'
import { IImpersonationResponse } from 'infrastructure/api'
import { ConfirmDialog } from 'shared/ui'

const EndImpersonationButton = ({
  encryptedData,
  onStopImpersonationSuccess,
}: {
  encryptedData: string
  onStopImpersonationSuccess: () => void
}) => {
  const [open, setOpen] = useState(false)
  const notify = useNotify()

  const endImpersonation = async () => {
    const url = `/v1/kat/users/impersonate/end`
    try {
      const body: IImpersonationResponse = {
        encrypted_data: encryptedData,
      }
      const { error } = await makeKiddomPostRequest({
        kiddomPath: url,
        requestBody: body,
      })
      if (error != null) {
        notify(error, { type: 'error' })
      } else {
        // If successful, cleanup session storage
        sessionStorage.removeItem('impersonationData')

        // Notify the parent to update the UI
        onStopImpersonationSuccess()
      }
    } catch {
      notify('Error occurred ending user impersonation.', {
        type: 'error',
      })
    }
    setOpen(false)
  }
  const title = 'Are you sure you want to end impersonating the user?'
  const buttonText = 'Stop Impersonating User'

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        {buttonText}
      </Button>
      <ConfirmDialog
        title={title}
        open={open}
        onClose={handleClose}
        onConfirm={endImpersonation}
      ></ConfirmDialog>
    </>
  )
}

export default EndImpersonationButton
